import React, { useEffect, useRef, useState } from "react";
import { useNotificationsRequest } from "hooks/useNotificationsRequest";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

export const WebSocketContext = React.createContext();

const PageWebsocketWrapper = ({ children }) => {
  const token = Cookies.get("token");
  const { pathname } = useLocation();
  const wsRef = useRef(null);
  const { fetchNotifications } = useNotificationsRequest();
  const notificationsFetched = useRef(false);
  const [wsData, setWsData] = useState(null);

  let retryTimeoutId;

  const createWebSocket = () => {
    if (!token || token.length === 0) {
      console.warn("Token is missing or invalid");
      return;
    }

    const socket = new WebSocket("wss://stage.twotwentyk.io/ws");
    wsRef.current = socket;

    socket.onopen = () => {
      console.log("WebSocket connection opened");
      socket.send(token);
    };

    socket.onmessage = (event) => {
      console.log("WebSocket new message");
      setWsData(event.data);
      fetchNotifications();
    };

    socket.onclose = (event) => {
      console.log("WebSocket connection closed", event);
      wsRef.current = null;

      if (event.wasClean) {
        console.log("Connection closed cleanly");
      } else {
        reconnectWithBackoff();
      }
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
      socket.close();
    };
  };

  const reconnectWithBackoff = (attempt = 1) => {
    const delay = Math.min(1000 * Math.pow(2, attempt), 30000);
    clearTimeout(retryTimeoutId);
    retryTimeoutId = setTimeout(() => {
      createWebSocket();
    }, delay);
  };

  useEffect(() => {
    if (token && !wsRef.current) {
      createWebSocket();
    }

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };
  }, [token]);

  useEffect(() => {
    if (!notificationsFetched.current) {
      fetchNotifications();
      notificationsFetched.current = true;
    }
  }, [pathname]);

  return (
    <WebSocketContext.Provider value={wsData}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default PageWebsocketWrapper;
